const SET_EDIT = 'SET_EDIT';
const setEditCall = (edit) => ({
    type: SET_EDIT,
    payload: edit,
});
const initialState = {
    edit: false,
};

const editReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_EDIT:
            return {
                ...state,
                edit: action.payload,
            };
        default:
            return state;
    }
};

export { setEditCall, editReducer };

const SET_EXPLO = 'SET_EXPLO';
const setExPoCall = (edit) => ({
    type: SET_EXPLO,
    payload: edit,
});
const initialState1 = {
    explo: false,
};

const expoReducer = (state = initialState1, action) => {
    switch (action.type) {
        case SET_EXPLO:
            return {
                ...state,
                explo: action.payload,
            };
        default:
            return state;
    }
};

export { setExPoCall, expoReducer };